import { MarketPeriods as MarketPeriodsTypes } from "app/utils/const";
import { Component } from "react";
import { marketPeriodHelper } from "../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketPeriodType,
  EventType,
} from "../../../../../../types/eventType";
import MarketPeriodsMarketTypes from "./components/MarketPeriodsMarketTypes/MarketPeriodsMarketTypes";
import "./MarketPeriods.scss";
type Props = {
  event: EventType;
  marketPeriod: EventMarketPeriodType;
  className: string;
};
//
type State = {
  isActive: boolean;
}; //
class MarketPeriods extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // temp placeholder display feature
    if (
      this.props.marketPeriod.marketPeriod === MarketPeriodsTypes.FULL_EVENT ||
      this.props.marketPeriod.marketPeriod === MarketPeriodsTypes.EXTRA_TIME ||
      this.props.marketPeriod.marketPeriod === MarketPeriodsTypes.FIRST_HALF ||
      this.props.marketPeriod.marketPeriod === MarketPeriodsTypes.SECOND_HALF
    ) {
      this.props.marketPeriod.isActive = true;
    } else {
      this.props.marketPeriod.isActive = false;
    }

    this.state = {
      isActive: this.props.marketPeriod.isActive,
    };
  }

  toggle: () => void = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };

  render() {
    const { event, marketPeriod } = this.props;
    return (
      <div className="unsummarized-markets-modal__market-periods-summary">
        <div className="collapsible-content">
          {marketPeriodHelper.hasMarketPeriodAnyRunners(
            this.props.marketPeriod
          ) &&
            marketPeriod.marketTypes != null &&
            marketPeriod.marketTypes.map((marketType, index) => {
              return (
                <MarketPeriodsMarketTypes
                  key={"market-period-summary-market-types" + index + event.id}
                  event={event}
                  marketPeriod={marketPeriod}
                  marketType={marketType}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

export default MarketPeriods;
